(function (process,global,Buffer,__argument0,__argument1,__argument2,__argument3,__filename,__dirname){
const schemata = require('schemata')
const required = require('@clocklimited/validity-required')

//  , urlValidity = require('validity-url-optional-tlds')()

module.exports = function () {

  return schemata(
    { _id:
      { type: String
      }
    , name:
      { type: String
      , validators:
        { all: [ required ]
        }
      }
    , company:
      { type: String
      }
    , email:
      { type: String
      , validators:
        { all: [ required ]
        }
      }
    , phone:
      { type: String
      , validators:
        { all: [ required ]
        }
      }
    , mobile:
      { type: String
      , validators:
        { all: [ required ]
        }
      }
    , website:
      { type: String
      }
    , addressLine1:
      { type: String
      }
    , addressLine2:
      { type: String
      }
    , postcode:
      { type: String
      }
    , city:
      { type: String
      }
    , country:
      { type: String
      }
    , twitter:
      { type: String
      }
    , facebook:
      { type: String
      }
    , position:
      { type: String
      , validators:
        { all: [ required ]
        }
      }
    , blacklist:
      { type: Boolean
      , defaultValue: false
      }
    , blacklistHistory:
      { type: Array
      , defaultValue: []
      }
    , dateCreated:
      { type: Date
      , defaultValue: function () { return new Date() }
      }
    , updateDate:
      { type: Date
      , defaultValue: function () { return new Date() }
      }
    }
  )
}

}).call(this,require('_process'),typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {},require("buffer").Buffer,arguments[3],arguments[4],arguments[5],arguments[6],"/components/service/contact/schema.js","/components/service/contact")
//# sourceMappingURL=data:application/json;charset:utf-8;base64,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